import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';

import * as GlobeActions from '~app/actions/globe';

import MenuItem from './MenuItem';
import Modal from './Modal';
import SettingsMenu from './SettingsMenu';

class MenuBar extends Component {

  static propTypes = {
    isGlobe: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isGlobe: true,
  };

  state = {
    isSettingsOpen: false,
  }

  toggleSettingsMenu() {
    this.setState({isSettingsOpen: !this.state.isSettingsOpen});
  }

  orientGlobe() {
    // FlyTo always ends with north oriented up.
    // If we pass no location, it means don't move, just re-orient.
    this.props.flyTo();
  }

  render() {
    return (
      <div className="MenuBar">
        <div ref="target">
          <MenuItem
            styleName="settings"
            onClick={::this.toggleSettingsMenu}
          />
        </div>

        <MenuItem
          styleName={this.props.isGlobe ? "globe" : "map"}
          onClick={this.props.morph}
        />

        <MenuItem
          styleName={"compass"}
          onClick={::this.orientGlobe}
        />

        <Modal
          target={ props => findDOMNode(this.refs.target)}
          placement="bottom"
          show={this.state.isSettingsOpen}
          onHide={::this.toggleSettingsMenu}
        >
          <SettingsMenu
            onClose={::this.toggleSettingsMenu}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isGlobe: (state.globe.mode === "3D"),
});

const mapDispatchToProps = {
  morph: GlobeActions.morphGlobe,
  flyTo: GlobeActions.flyTo,
};

export { MenuBar };
export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);



// WEBPACK FOOTER //
// ./src/components/MenuBar.js